import { render, staticRenderFns } from "./WhitelabelEditor.vue?vue&type=template&id=499719c3&"
import script from "./WhitelabelEditor.vue?vue&type=script&lang=ts&"
export * from "./WhitelabelEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports